import React, { useState } from 'react';
import { Mail, Phone, MapPin } from 'lucide-react';
import { Modal } from '../ui/Modal';
export function Footer() {
  const [isContactOpen, setIsContactOpen] = useState(false);
  return <>
      <footer className="bg-brand-dark text-white py-12 px-4" data-id="element-32">
        <div className="max-w-6xl mx-auto" data-id="element-33">
          {/* Main Footer Content */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8" data-id="element-34">
            {/* Brand */}
            <div data-id="element-35">
              <h3 className="text-xl font-serif font-bold mb-3" data-id="element-36">
                Las 7 Claves para la Menopausia 40+
              </h3>
              <p className="text-white/70 text-sm" data-id="element-37">
                El protocolo natural diseñado para recuperar tu bienestar
                después de los 40.
              </p>
            </div>

            {/* Links */}
            <div data-id="element-38">
              <h4 className="font-semibold mb-3" data-id="element-39">Legal</h4>
              <ul className="space-y-2 text-sm" data-id="element-40">
                <li data-id="element-41">
                  <a href="/privacy" target="_blank" rel="noopener noreferrer" className="text-white/70 hover:text-white transition-colors" data-id="element-42">
                    Política de Privacidad
                  </a>
                </li>
                <li data-id="element-43">
                  <a href="/terms" target="_blank" rel="noopener noreferrer" className="text-white/70 hover:text-white transition-colors" data-id="element-44">
                    Términos y Condiciones
                  </a>
                </li>
              </ul>
            </div>

            {/* Contact */}
            <div data-id="element-45">
              <h4 className="font-semibold mb-3" data-id="element-46">Contacto</h4>
              <button onClick={() => setIsContactOpen(true)} className="text-white/70 hover:text-white transition-colors text-sm text-left underline" data-id="element-47">
                Ver información de contacto
              </button>
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="pt-8 border-t border-white/10 text-center" data-id="element-48">
            <p className="text-white/60 text-sm" data-id="element-49">
              © {new Date().getFullYear()} Las 7 Claves para la Menopausia 40+.
              Todos los derechos reservados.
            </p>
            <p className="mt-2 text-xs text-white/40 max-w-2xl mx-auto" data-id="element-50">
              Este sitio no pretende diagnosticar, tratar, curar o prevenir
              ninguna enfermedad. La información proporcionada es solo para
              fines educativos. Consulte siempre a su médico antes de comenzar
              cualquier dieta o programa de salud.
            </p>
          </div>
        </div>
      </footer>

      {/* Contact Modal */}
      <Modal isOpen={isContactOpen} onClose={() => setIsContactOpen(false)} title="Información de Contacto" data-id="element-51">
        <div className="space-y-6" data-id="element-52">
          <div className="flex items-start gap-4" data-id="element-53">
            <div className="w-10 h-10 bg-brand-lavenderLight rounded-full flex items-center justify-center flex-shrink-0" data-id="element-54">
              <Mail className="w-5 h-5 text-brand-lavender" data-id="element-55" />
            </div>
            <div data-id="element-56">
              <h4 className="font-semibold text-brand-dark mb-1" data-id="element-57">Email</h4>
              <a href="mailto:contacto@vitalizateahora.com" className="text-brand-lavender hover:underline" data-id="element-58">
                contacto@vitalizateahora.com
              </a>
            </div>
          </div>

          <div className="flex items-start gap-4" data-id="element-59">
            <div className="w-10 h-10 bg-brand-lavenderLight rounded-full flex items-center justify-center flex-shrink-0" data-id="element-60">
              <Phone className="w-5 h-5 text-brand-lavender" data-id="element-61" />
            </div>
            <div data-id="element-62">
              <h4 className="font-semibold text-brand-dark mb-1" data-id="element-63">Teléfono</h4>
              <a href="tel:+1234567890" className="text-brand-lavender hover:underline" data-id="element-64">
                +1 (234) 567-890
              </a>
            </div>
          </div>

          <div className="flex items-start gap-4" data-id="element-65">
            <div className="w-10 h-10 bg-brand-lavenderLight rounded-full flex items-center justify-center flex-shrink-0" data-id="element-66">
              <MapPin className="w-5 h-5 text-brand-lavender" data-id="element-67" />
            </div>
            <div data-id="element-68">
              <h4 className="font-semibold text-brand-dark mb-1" data-id="element-69">Dirección</h4>
              <p className="text-brand-dark/70" data-id="element-70">
                123 Calle Principal
                <br data-id="element-71" />
                Ciudad, Estado 12345
                <br data-id="element-72" />
                País
              </p>
            </div>
          </div>

          <div className="pt-4 border-t border-brand-lavenderLight" data-id="element-73">
            <p className="text-sm text-brand-dark/70" data-id="element-74">
              Horario de atención: Lunes a Viernes, 9:00 AM - 6:00 PM
            </p>
          </div>
        </div>
      </Modal>
    </>;
}